var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficeBag = function SvgOfficeBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 47 46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.652 29.766H8.348a3.79 3.79 0 0 1-3.787-3.788v-8.485a4.773 4.773 0 0 1 4.772-4.772h28.41a4.773 4.773 0 0 1 4.696 4.772v8.485a3.79 3.79 0 0 1-3.788 3.788",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.651 29.765H8.348a3.8 3.8 0 0 1-1.894-.511v6.193a3.79 3.79 0 0 0 3.788 3.788h26.515a3.79 3.79 0 0 0 3.788-3.788v-6.193a3.8 3.8 0 0 1-1.894.511M26.815 27.454h-5.36a1.42 1.42 0 0 1 0-2.84h5.36a1.42 1.42 0 1 1 0 2.84M29.75 14.14a1.42 1.42 0 0 1-1.42-1.42v-1.25a1.894 1.894 0 0 0-1.894-1.894H21.89a1.894 1.894 0 0 0-1.894 1.894v1.193a1.42 1.42 0 0 1-2.84 0V11.47a4.773 4.773 0 0 1 4.772-4.773h4.489a4.773 4.773 0 0 1 4.753 4.773v1.193a1.42 1.42 0 0 1-1.42 1.477"
  }))));
};
export default SvgOfficeBag;